import { createContext } from 'react';

import type * as types from './types';

export const SuspendedPopoverClickAwayContextObj =
  createContext<null | types.SuspendedPopoverClickAwayContext>(null);
